import { render } from "./GameScore.vue?vue&type=template&id=4d79ab3c&scoped=true"
import script from "./GameScore.vue?vue&type=script&lang=js"
export * from "./GameScore.vue?vue&type=script&lang=js"

import "./GameScore.vue?vue&type=style&index=0&id=4d79ab3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d79ab3c"]])

export default __exports__